import * as types from './meetings-simple.types';
export const meetingsSimplePageSelectors: types.IMeetingSimplePageSelectors = {
  selectMeetingsSimple: (state) => state.page.meetingsSimple.meetingsSimpleIds,
  selectAccounts: (state) => state.page.meetingsSimple.accountIds,
  selectTeams: (state) => state.page.meetingsSimple.teamIds,
  selectNextMeeting: (state) => state.page.meetingsSimple.nextMeeting,
  selectStartedMeetings: (state) => state.page.meetingsSimple.startedMeetings,
  selectFilteredMeetings: (state) => state.page.meetingsSimple.filteredMeetings,
  selectLiveMeetings: (state) => state.page.meetingsSimple.liveMeetings,
  selectIsFetched: (state) => state.page.meetingsSimple.isFetched,
  selectIsUpdateMeetingComplete: (state) => state.page.meetingsSimple.isUpdateMeetingComplete,
};
